/**
 * @method getBookPropertiesFromBackendData
 * @param {Object} epubLocationHistoryData - payload of location history data from the backend
 * @returns {Object} object containing a timestamp and a book primary key
 *                   or null if either property is unavailable
 */
const getBookPropertiesFromBackendData = (epubLocationHistoryData) => {
  if (!epubLocationHistoryData) {
    return null;
  }

  const { lastModified, epub } = epubLocationHistoryData;

  if (!lastModified || !epub?.pk) {
    return null;
  }

  return {
    timestamp: +new Date(lastModified),
    pk: parseInt(epub.pk),
  };
};

export default getBookPropertiesFromBackendData;
